import { render, staticRenderFns } from "./ViolationsTab.vue?vue&type=template&id=49516dcf&"
import script from "./ViolationsTab.vue?vue&type=script&lang=js&"
export * from "./ViolationsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports